
const InfiniteScroll = require('infinite-scroll');

let infScroll = new InfiniteScroll( '.post-grid', {
    // options
    elementScroll: '.post',
    path: '.next',
    append: '.article-grid--item',
    history: false,
});